import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Tooltip from "@mui/material/Tooltip";
import markets from "./markets";
import { getJSON } from "../utils/safeLocalStorage";
import { getRowCurrency } from "../utils/currencyUtils";
import { formatDateTimeInServerTime } from "../utils/timezones";
import moment from "moment-timezone";

const ColumnsAll = (
  theme,
  throwMessage,
  idTradeGenerator,
  runDurationCal,
  handleOpenJournal,
  auth,
  calculateFields,
  selectedAccountId = null,
) => {
  const checkStopLossType = (p) => {
    const pairObject = markets.find((m) => m.ticker === p);
    if (pairObject?.multiplier === 10) {
      return "Ticks";
    } else if (pairObject?.multiplier === 1) {
      return "Pips";
    }
  };

  // Helper function to convert date/time to selected timezone
  const formatDateTimeInTimezone = (dateStr, timeStr, originalTimezone) => {
    if (!dateStr) return "";

    try {
      // Get the user's selected timezone from settings
      const storedTimezone = localStorage.getItem("economic-calendar-timezone");
      const targetTimezone =
        storedTimezone && storedTimezone !== "local"
          ? storedTimezone
          : Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Parse the date/time in the original timezone the trade was taken in
      const dateTimeStr = timeStr ? `${dateStr} ${timeStr}` : dateStr;
      const originalMoment = moment.tz(
        dateTimeStr,
        "DD/MM/YY HH:mm",
        originalTimezone || "UTC",
      );

      // Convert to the selected timezone
      const convertedMoment = originalMoment.clone().tz(targetTimezone);

      // Format for display
      const formattedDate = convertedMoment.format("DD/MM/YY");
      const formattedTime = convertedMoment.format("HH:mm");

      return timeStr ? `${formattedDate} ${formattedTime}` : formattedDate;
    } catch (error) {
      console.error("Error converting timezone:", error);
      // Fallback to original values if conversion fails
      return timeStr ? `${dateStr} ${timeStr}` : dateStr;
    }
  };

  // Helper function to get timezone offset from timezone string
  const getTimezoneOffset = (timezone) => {
    if (!timezone) return "";
    try {
      const now = moment();
      const offset = now.tz(timezone).utcOffset();
      const hours = Math.floor(Math.abs(offset) / 60);
      const sign = offset >= 0 ? "+" : "-";
      return `${sign}${hours}`;
    } catch (error) {
      console.error("Error getting timezone offset:", error);
      return "";
    }
  };
  // const checkSession = (p) => {
  //   const found = markets.find((m) => m.ticker === p.row.pair);
  //   let session = found.session;

  //   let entryDate = p.row.entryDate.split(/\//);
  //   let exitDate = p.row.exitDate.split(/\//);

  //   entryDate = [entryDate[1], entryDate[0], entryDate[2]].join("/");
  //   exitDate = [exitDate[1], exitDate[0], exitDate[2]].join("/");

  //   const date = {
  //     entryDate: entryDate,
  //     entryTime: p.row.entryTime,
  //     exitDate: exitDate,
  //     exitTime: p.row.exitTime,
  //   };

  //   let startDate = moment(new Date(date.entryDate + " " + date.entryTime)).tz(
  //     p.row.timezone
  //   );

  //   let start;
  //   let end;

  //   startDate = startDate.utc().format();

  //   startDate = startDate.split("T")[1].split(":");

  //   startDate = startDate[0] + startDate[1];

  //   console.log("found", p.row.pair);
  //   console.log("startDate", startDate);

  //   const current_time = moment().utc().format();

  //   const UKDaylightSavings = moment.tz(current_time, "Europe/London").isDST();

  //   if (!UKDaylightSavings) {
  //     start = moment(session.split("-")[0], "HH:mm")
  //       .subtract(1, "hours")
  //       .format("HH:mm");
  //     end = moment(session.split("-")[1], "HH:mm")
  //       .subtract(1, "hours")
  //       .format("HH:mm");
  //   } else {
  //     start = moment(session.split("-")[0], "HH:mm")
  //       .add(1, "hours")
  //       .format("HH:mm");
  //     end = moment(session.split("-")[1], "HH:mm")
  //       .add(1, "hours")
  //       .format("HH:mm");
  //   }

  //   if (startDate >= start && startDate <= end) {
  //     return "True";
  //   } else {
  //     return "False";
  //   }

  //   // console.log(session.split("-")[0])
  //   // console.log(session.split("-")[1])
  // };

  const user = getJSON("user", {});
  const capitalAccounts = user.capitalAccounts || [];
  const getAccountForTrade = (row) =>
    capitalAccounts.find((acc) => acc.id === row.accountId);

  let array = [
    {
      field: "pair",
      headerName: "Instrument",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.pair) {
          return "";
        }
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <p
              style={{
                cursor: "pointer",
                color: params.row.journalComplete
                  ? theme[0] === "dark"
                    ? "#FCFCFF"
                    : "black"
                  : "#f23645",
                fontWeight: "400",
                margin: 0,
              }}
              onClick={() => {
                if (!params.row.journalID) {
                  throwMessage("error", "No Journal Found");
                  handleOpenJournal(params.row, true);
                } else {
                  handleOpenJournal(params.row, true);
                }
              }}
            >
              {params.row.pair}
            </p>
            {params.row.foreCastId ? (
              <span
                style={{
                  cursor: "pointer",
                  backgroundColor: "#26a65d",
                  color: "white",
                  fontSize: "10px",
                  padding: "1px 4px",
                  borderRadius: "3px",
                  fontWeight: "600",
                }}
                onClick={() => {
                  localStorage.setItem(
                    "forecast-to-view",
                    params.row.foreCastId,
                  );
                  localStorage.setItem("screen", 0);
                  auth.setTab(0);
                  localStorage.setItem("from-tracker", true);
                  // Save the current filter state before opening forecast
                  localStorage.setItem(
                    "tracker-trade-filter-before-forecast",
                    localStorage.getItem("trade-to-view") || "",
                  );
                  localStorage.setItem(
                    "tracker-linked-filter-before-forecast",
                    localStorage.getItem("linked-trade-ids") || "",
                  );
                }}
              >
                F
              </span>
            ) : (
              <span
                style={{
                  cursor: "pointer",
                  backgroundColor: "#f23645",
                  color: "white",
                  fontSize: "10px",
                  padding: "1px 4px",
                  borderRadius: "3px",
                  fontWeight: "600",
                }}
                onClick={() => {
                  throwMessage("info", "No Forecast Attached");
                }}
              >
                F
              </span>
            )}
          </div>
        );
      },
    },
    {
      field: "direction",
      headerName: "Direction",
      width: 80,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.direction) {
          return "";
        }
        return (
          <p
            style={{
              color:
                params.row.direction === "Short"
                  ? "#db0671"
                  : params.row.direction === "Long"
                    ? "#0079cf"
                    : "",
            }}
          >
            {params.row.direction}
          </p>
        );
      },
    },
    {
      field: "tradingStyle",
      headerName: "Style",
      width: 80,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.tradingStyle) {
          return "";
        }
        return (
          <p
            style={{
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
              fontSize: "13px",
            }}
          >
            {params.row.tradingStyle}
          </p>
        );
      },
    },
    {
      field: "outcomePC",
      headerName: "Outcome",
      width: 80,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.outcomePC) {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        } else {
          return (
            <p
              style={{
                color:
                  params.row.outcomePC === "Loss"
                    ? "#f23645"
                    : params.row.outcomePC === "Win"
                      ? "#26a65d"
                      : params.row.outcomePC === "Breakeven"
                        ? "#ED9E0E"
                        : "",
              }}
            >
              {params.row.outcomePC}
            </p>
          );
        }
      },
    },
    {
      field: "outcomeIC",
      headerName: "Outcome",
      width: 80,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.outcomeIC) {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        } else {
          return (
            <p
              style={{
                color:
                  params.row.outcomeIC === "Loss"
                    ? "#f23645"
                    : params.row.outcomeIC === "Win"
                      ? "#26a65d"
                      : params.row.outcomeIC === "Breakeven"
                        ? "#ED9E0E"
                        : "",
              }}
            >
              {params.row.outcomeIC}
            </p>
          );
        }
      },
    },
    {
      field: "feePC",
      headerName: "Fee",
      width: 90,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          if (!params.row.feePC) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    params.row.feePC < 0
                      ? "#f23645"
                      : params.row.feePC > 0
                        ? "#26a65d"
                        : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(params.row.feePC).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "swapPC",
      headerName: "Swap",
      width: 90,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          if (!params.row.swapPC) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    params.row.swapPC < 0
                      ? "#f23645"
                      : params.row.swapPC > 0
                        ? "#26a65d"
                        : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(params.row.swapPC).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "feeIC",
      headerName: "Fee",
      width: 90,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          if (!params.row.feeIC) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    params.row.feeIC < 0
                      ? "#f23645"
                      : params.row.feeIC > 0
                        ? "#26a65d"
                        : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(params.row.feeIC).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "swapIC",
      headerName: "Swap",
      width: 90,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          if (!params.row.swapIC) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    params.row.swapIC < 0
                      ? "#f23645"
                      : params.row.swapIC > 0
                        ? "#26a65d"
                        : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(params.row.swapIC).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    // ========== PERSONAL CAPITAL COLUMNS ==========
    {
      field: "profitLossPercentagePC",
      headerName: "% Gross",
      width: 80,
      valueFormatter: ({ value }) => `${value} %`,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          if (!params.row.profitLossPercentagePC) {
            return <p style={{ color: "#ED9E0E" }}>0 %</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    params.row.profitLossPercentagePC < 0
                      ? "#f23645"
                      : params.row.profitLossPercentagePC > 0
                        ? "#26a65d"
                        : "#ED9E0E",
                }}
              >
                {Math.abs(params.row.profitLossPercentagePC).toFixed(2)} %
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "percentWithFeesPC",
      headerName: "% Net",
      width: 110,
      valueFormatter: ({ value }) => `${value} %`,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          const value =
            params.row.percentWithFeesPC ??
            params.row.profitLossPercentagePC ??
            0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>0 %</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    value < 0 ? "#f23645" : value > 0 ? "#26a65d" : "#ED9E0E",
                }}
              >
                {Math.abs(value).toFixed(2)} %
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "profitLossDollarPersonal",
      headerName: "P/L Gross",
      width: 110,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          if (!params.row.profitLossDollarPersonal) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    params.row.profitLossDollarPersonal < 0
                      ? "#f23645"
                      : params.row.profitLossDollarPersonal > 0
                        ? "#26a65d"
                        : "#ED9E0E",
                }}
              >
                {currency}{" "}
                {Math.abs(params.row.profitLossDollarPersonal).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "returnNetPersonal",
      headerName: "P/L Net",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          const profitLoss =
            parseFloat(params.row.profitLossDollarPersonal) || 0;
          const fee = parseFloat(params.row.feePC) || 0;
          const swap = parseFloat(params.row.swapPC) || 0;
          const returnNet = profitLoss + fee + swap;
          if (!returnNet) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    returnNet < 0
                      ? "#f23645"
                      : returnNet > 0
                        ? "#26a65d"
                        : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(returnNet).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "rollingPercentPCGross",
      headerName: "Cuml % Gross",
      width: 110,
      valueFormatter: ({ value }) => `${value} %`,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          const value = params.row.rollingPercentPCGross ?? 0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>0 %</p>;
          }
          return (
            <p
              style={{
                color:
                  value < 0 ? "#f23645" : value > 0 ? "#26a65d" : "#ED9E0E",
              }}
            >
              {Math.abs(value).toFixed(2)} %
            </p>
          );
        }
        return (
          <HorizontalRuleIcon
            sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
          />
        );
      },
    },
    {
      field: "rollingPercentPCNet",
      headerName: "Cuml % Net",
      width: 110,
      valueFormatter: ({ value }) => `${value} %`,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          const value = params.row.rollingPercentPCNet ?? 0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>0 %</p>;
          }
          return (
            <p
              style={{
                color:
                  value < 0 ? "#f23645" : value > 0 ? "#26a65d" : "#ED9E0E",
              }}
            >
              {Math.abs(value).toFixed(2)} %
            </p>
          );
        }
        return (
          <HorizontalRuleIcon
            sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
          />
        );
      },
    },
    {
      field: "returnTotalsPersonalGross",
      headerName: "Cuml $ Gross",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          const value = params.row.returnTotalsPersonalGross ?? 0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    value < 0 ? "#f23645" : value > 0 ? "#26a65d" : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(value).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "returnTotalsPersonal",
      headerName: "Cuml $ Net",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          const value = params.row.returnTotalsPersonal ?? 0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    value < 0 ? "#f23645" : value > 0 ? "#26a65d" : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(value).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "rollingFeesPC",
      headerName: "Cuml Fees",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          const value = params.row.rollingFeesPC ?? 0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    value < 0 ? "#f23645" : value > 0 ? "#26a65d" : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(value).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "rollingBalancePCGross",
      headerName: "Balance Gross",
      width: 185,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          const value = params.row.rollingBalancePCGross ?? 0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            // For backtest, use 10000 as starting balance, for personal capital use user's starting balance
            const start =
              params.row.equityType === "Backtest"
                ? 10000
                : Number(
                    JSON.parse(localStorage.getItem("user")).startingBalancePC,
                  );
            return (
              <p
                style={{
                  color:
                    value < start
                      ? "#f23645"
                      : value > start
                        ? "#26a65d"
                        : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(value).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "rollingBalancePC",
      headerName: "Balance Net",
      width: 185,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          const value = params.row.rollingBalancePC ?? 0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            // For backtest, use 10000 as starting balance, for personal capital use user's starting balance
            const start =
              params.row.equityType === "Backtest"
                ? 10000
                : Number(
                    JSON.parse(localStorage.getItem("user")).startingBalancePC,
                  );
            return (
              <p
                style={{
                  color:
                    value < start
                      ? "#f23645"
                      : value > start
                        ? "#26a65d"
                        : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(value).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "lotsPC",
      headerName: "Lots",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          if (
            params.row.lotsPC === "" ||
            params.row.lotsPC === null ||
            params.row.lotsPC === undefined
          ) {
            return (
              <HorizontalRuleIcon
                sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
              />
            );
          }
          return <p>{params.row.lotsPC}</p>;
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "unitsPC",
      headerName: "Units",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          if (
            params.row.unitsPC === "" ||
            params.row.unitsPC === null ||
            params.row.unitsPC === undefined
          ) {
            return (
              <HorizontalRuleIcon
                sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
              />
            );
          }
          return <p>{params.row.unitsPC}</p>;
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "moneyPC",
      headerName: "Risk",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (
          params.row.equityType === "Personal Capital" ||
          params.row.equityType === "Backtest"
        ) {
          if (
            params.row.moneyPC === "" ||
            params.row.moneyPC === null ||
            params.row.moneyPC === undefined
          ) {
            return (
              <HorizontalRuleIcon
                sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
              />
            );
          }
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          return (
            <p>
              {currency} {Math.abs(params.row.moneyPC).toFixed(2)}
            </p>
          );
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },

    // ========== INVESTOR CAPITAL COLUMNS ==========
    {
      field: "profitLossPercentageIC",
      headerName: "% Gross",
      width: 80,
      valueFormatter: ({ value }) => `${value} %`,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          if (!params.row.profitLossPercentageIC) {
            return <p style={{ color: "#ED9E0E" }}>0 %</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    params.row.profitLossPercentageIC < 0
                      ? "#f23645"
                      : params.row.profitLossPercentageIC > 0
                        ? "#26a65d"
                        : "#ED9E0E",
                }}
              >
                {Math.abs(params.row.profitLossPercentageIC).toFixed(2)} %
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "percentWithFeesIC",
      headerName: "% Net",
      width: 110,
      valueFormatter: ({ value }) => `${value} %`,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          const value =
            params.row.percentWithFeesIC ??
            params.row.profitLossPercentageIC ??
            0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>0 %</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    value < 0 ? "#f23645" : value > 0 ? "#26a65d" : "#ED9E0E",
                }}
              >
                {Math.abs(value).toFixed(2)} %
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "profitLossDollarInvestor",
      headerName: "P/L Gross",
      width: 110,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          if (!params.row.profitLossDollarInvestor) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    params.row.profitLossDollarInvestor < 0
                      ? "#f23645"
                      : params.row.profitLossDollarInvestor > 0
                        ? "#26a65d"
                        : "#ED9E0E",
                }}
              >
                {currency}{" "}
                {Math.abs(params.row.profitLossDollarInvestor).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "returnNetInvestor",
      headerName: "P/L Net",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          const profitLoss =
            parseFloat(params.row.profitLossDollarInvestor) || 0;
          const fee = parseFloat(params.row.feeIC) || 0;
          const swap = parseFloat(params.row.swapIC) || 0;
          const returnNet = profitLoss + fee + swap;
          if (!returnNet) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    returnNet < 0
                      ? "#f23645"
                      : returnNet > 0
                        ? "#26a65d"
                        : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(returnNet).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "rollingPercentICGross",
      headerName: "Cuml % Gross",
      width: 110,
      valueFormatter: ({ value }) => `${value} %`,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          const value = params.row.rollingPercentICGross ?? 0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>0 %</p>;
          }
          return (
            <p
              style={{
                color:
                  value < 0 ? "#f23645" : value > 0 ? "#26a65d" : "#ED9E0E",
              }}
            >
              {Math.abs(value).toFixed(2)} %
            </p>
          );
        }
        return (
          <HorizontalRuleIcon
            sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
          />
        );
      },
    },
    {
      field: "rollingPercentICNet",
      headerName: "Cuml % Net",
      width: 110,
      valueFormatter: ({ value }) => `${value} %`,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          const value = params.row.rollingPercentICNet ?? 0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>0 %</p>;
          }
          return (
            <p
              style={{
                color:
                  value < 0 ? "#f23645" : value > 0 ? "#26a65d" : "#ED9E0E",
              }}
            >
              {Math.abs(value).toFixed(2)} %
            </p>
          );
        }
        return (
          <HorizontalRuleIcon
            sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
          />
        );
      },
    },
    {
      field: "returnTotalsInvestorGross",
      headerName: "Cuml $ Gross",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          const value = params.row.returnTotalsInvestorGross ?? 0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    value < 0 ? "#f23645" : value > 0 ? "#26a65d" : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(value).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "returnTotalsInvestor",
      headerName: "Cuml $ Net",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          const value = params.row.returnTotalsInvestor ?? 0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    value < 0 ? "#f23645" : value > 0 ? "#26a65d" : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(value).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "rollingFeesIC",
      headerName: "Cuml Fees",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          const value = params.row.rollingFeesIC ?? 0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            return (
              <p
                style={{
                  color:
                    value < 0 ? "#f23645" : value > 0 ? "#26a65d" : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(value).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "rollingBalanceICGross",
      headerName: "Balance Gross",
      width: 185,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          const value = params.row.rollingBalanceICGross ?? 0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            const start = Number(
              JSON.parse(localStorage.getItem("user")).startingBalanceIC,
            );
            return (
              <p
                style={{
                  color:
                    value < start
                      ? "#f23645"
                      : value > start
                        ? "#26a65d"
                        : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(value).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "rollingBalanceIC",
      headerName: "Balance Net",
      width: 185,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          const value = params.row.rollingBalanceIC ?? 0;
          if (!value) {
            return <p style={{ color: "#ED9E0E" }}>{currency} 0</p>;
          } else {
            const start = Number(
              JSON.parse(localStorage.getItem("user")).startingBalanceIC,
            );
            return (
              <p
                style={{
                  color:
                    value < start
                      ? "#f23645"
                      : value > start
                        ? "#26a65d"
                        : "#ED9E0E",
                }}
              >
                {currency} {Math.abs(value).toFixed(2)}
              </p>
            );
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "lotsIC",
      headerName: "Lots",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          if (
            params.row.lotsIC === "" ||
            params.row.lotsIC === null ||
            params.row.lotsIC === undefined
          ) {
            return (
              <HorizontalRuleIcon
                sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
              />
            );
          }
          return <p>{params.row.lotsIC}</p>;
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "unitsIC",
      headerName: "Units",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          if (
            params.row.unitsIC === "" ||
            params.row.unitsIC === null ||
            params.row.unitsIC === undefined
          ) {
            return (
              <HorizontalRuleIcon
                sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
              />
            );
          }
          return <p>{params.row.unitsIC}</p>;
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "moneyIC",
      headerName: "Risk",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          if (
            params.row.moneyIC === "" ||
            params.row.moneyIC === null ||
            params.row.moneyIC === undefined
          ) {
            return (
              <HorizontalRuleIcon
                sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
              />
            );
          }
          const currency = getRowCurrency(params.row, selectedAccountId, user);
          return (
            <p>
              {currency} {Math.abs(params.row.moneyIC).toFixed(2)}
            </p>
          );
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "risk",
      headerName: "Risk %",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (
          params.row.risk === null ||
          params.row.risk === undefined ||
          params.row.risk === ""
        ) {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
        const riskValue = parseFloat(params.row.risk);
        let color;
        if (riskValue <= 1) {
          color = "#26a65d";
        } else if (riskValue > 1 && riskValue <= 1.1) {
          color = "#ED9E0E";
        } else {
          color = "#f23645";
        }
        const displayValue = riskValue === 1 ? "1" : riskValue.toFixed(2);
        return (
          <p style={{ color: color, fontWeight: "600" }}>{displayValue} %</p>
        );
      },
    },
    {
      field: "entryServerTime",
      headerName: "Entry (Server)",
      width: 130,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        const account = getAccountForTrade(params.row);
        const value = formatDateTimeInServerTime(
          params.row.entryDate,
          params.row.entryTime,
          params.row.timezone,
          account,
        );
        return (
          <p
            style={{
              color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
              fontSize: "0.85rem",
            }}
          >
            {value || "-"}
          </p>
        );
      },
    },
    {
      field: "entryDateTime",
      headerName: "Entry (Local)",
      width: 130,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const d = params.row.entryDate;
        const t = params.row.entryTime;
        const tz = params.row.timezone;
        if (!d && !t) {
          return "";
        }
        const convertedDateTime = formatDateTimeInTimezone(d, t, tz);
        return <p>{convertedDateTime}</p>;
      },
    },
    {
      field: "exitDateTime",
      headerName: "Exit (Local)",
      width: 130,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const d = params.row.exitDate;
        const t = params.row.exitTime;
        const tz = params.row.timezone;
        if (!d && !t) {
          return "";
        }
        const convertedDateTime = formatDateTimeInTimezone(d, t, tz);
        return <p>{convertedDateTime}</p>;
      },
    },
    {
      field: "exitServerTime",
      headerName: "Exit (Server)",
      width: 130,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        const account = getAccountForTrade(params.row);
        const value = formatDateTimeInServerTime(
          params.row.exitDate,
          params.row.exitTime,
          params.row.timezone,
          account,
        );
        return (
          <p
            style={{
              color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
              fontSize: "0.85rem",
            }}
          >
            {value || "-"}
          </p>
        );
      },
    },
    {
      field: "duration",
      headerName: "Duration",
      width: 90,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        // Calculate duration from entry and exit dates/times
        const entryDate = params.row.entryDate;
        const entryTime = params.row.entryTime;
        const exitDate = params.row.exitDate;
        const exitTime = params.row.exitTime;

        if (!entryDate || !entryTime || !exitDate || !exitTime) {
          return <span>-</span>;
        }

        // Parse dates in DD/MM/YY format (non-American)
        const parseDate = (dateStr) => {
          const parts = dateStr.split("/");
          if (parts.length !== 3) return null;
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10) - 1; // JavaScript months are 0-indexed
          const year =
            parts[2].length === 2
              ? 2000 + parseInt(parts[2], 10)
              : parseInt(parts[2], 10);
          return new Date(year, month, day);
        };

        const entryDateTime = parseDate(entryDate);
        const exitDateTime = parseDate(exitDate);

        if (
          !entryDateTime ||
          !exitDateTime ||
          isNaN(entryDateTime.getTime()) ||
          isNaN(exitDateTime.getTime())
        ) {
          return <span>-</span>;
        }

        // Parse time (HH:MM format)
        const parseTime = (timeStr) => {
          const parts = timeStr.split(":");
          if (parts.length !== 2) return 0;
          return parseInt(parts[0], 10) + parseInt(parts[1], 10) / 60;
        };

        const entryHours = parseTime(entryTime);
        const exitHours = parseTime(exitTime);

        entryDateTime.setHours(entryHours);
        exitDateTime.setHours(exitHours);

        const diffMs = exitDateTime - entryDateTime;
        const diffHours = diffMs / (1000 * 60 * 60);

        if (diffHours === 0 || isNaN(diffHours)) {
          return <span>-</span>;
        }

        const days = (diffHours / 24).toFixed(1);

        return <p>{days > 1 ? days + "d" : diffHours.toFixed(1) + "h"}</p>;
      },
    },
    {
      field: "timezone",
      headerName: "Timezone",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.timezone) {
          return "";
        } else {
          const offset = getTimezoneOffset(params.row.timezone);
          return (
            <p
              style={{
                color: theme[0] === "dark" ? "#FCFCFF" : "black",
              }}
            >
              {offset}
            </p>
          );
        }
      },
    },
    {
      field: "duplicateStatus",
      headerName: "Multi",
      width: 80,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isDuplicate =
          params.row.duplicatedFrom && params.row.duplicatedFrom !== "";
        const hasDuplicates = auth.allTrades?.some(
          (trade) => trade.duplicatedFrom === params.row._id,
        );

        if (isDuplicate || hasDuplicates) {
          // Find related trade(s)
          let relatedTrades = [];
          if (isDuplicate) {
            // This is a duplicate, find the original
            const original = auth.allTrades?.find(
              (t) => t._id === params.row.duplicatedFrom,
            );
            if (original) relatedTrades.push(original);
            // Also find other duplicates of the same original
            const otherDuplicates = auth.allTrades?.filter(
              (t) =>
                t.duplicatedFrom === params.row.duplicatedFrom &&
                t._id !== params.row._id,
            );
            if (otherDuplicates) relatedTrades.push(...otherDuplicates);
          } else {
            // This is the original, find all duplicates
            relatedTrades =
              auth.allTrades?.filter(
                (t) => t.duplicatedFrom === params.row._id,
              ) || [];
          }

          // Build tooltip text
          const tooltipText =
            relatedTrades.length > 0
              ? relatedTrades
                  .map((t) => {
                    const user = JSON.parse(
                      localStorage.getItem("user") || "{}",
                    );
                    const accounts = user.capitalAccounts || [];
                    const account = accounts.find(
                      (acc) => acc.id === t.accountId,
                    );
                    const accountName = account ? account.name : "Unknown";
                    return `${t.pair} ${t.direction} - ${formatDateTimeInTimezone(t.entryDate, t.entryTime, t.timezone)} (${accountName})`;
                  })
                  .join("\n")
              : "No related trades found";

          return (
            <Tooltip
              title={
                <div style={{ whiteSpace: "pre-line", fontSize: "12px" }}>
                  <strong>
                    {isDuplicate ? "Related to:" : "Duplicated on:"}
                  </strong>
                  <br />
                  {tooltipText}
                </div>
              }
              arrow
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "4px",
                  width: "100%",
                  cursor: "pointer",
                }}
              >
                <ContentCopyIcon
                  sx={{
                    fontSize: "16px",
                    color: theme[0] === "dark" ? "#60a5fa" : "#3b82f6",
                  }}
                />
                <span
                  style={{
                    fontSize: "11px",
                    fontWeight: "600",
                    color: theme[0] === "dark" ? "#60a5fa" : "#3b82f6",
                  }}
                >
                  Yes
                </span>
              </div>
            </Tooltip>
          );
        }

        return (
          <HorizontalRuleIcon
            sx={{ color: theme[0] === "dark" ? "#6b7280" : "#9ca3af" }}
          />
        );
      },
    },
    {
      field: "highlightedPair",
      headerName: "Watchlist",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.highlightedPair) {
          return "";
        }
        return <p>{params.row.highlightedPair}</p>;
      },
    },
    {
      field: "grade",
      headerName: "Grade",
      width: 70,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.grade) {
          return "";
        }
        return (
          <p
            style={{
              color: "inherit",
            }}
          >
            {params.row.grade}
          </p>
        );
      },
    },
    {
      field: "entryType",
      headerName: "Entry Type",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.entryType) {
          return "";
        }
        return <p>{params.row.entryType}</p>;
      },
    },
    {
      field: "entryTimeframe",
      headerName: "Entry TF",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.entryTimeframe) {
          return "";
        }
        return <p>{params.row.entryTimeframe}</p>;
      },
    },

    {
      field: "firstEntryOrScaleIn",
      headerName: "Entry No",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.firstEntryOrScaleIn) {
          return "";
        }
        return <p>{params.row.firstEntryOrScaleIn}</p>;
      },
    },
    {
      field: "alphaPattern",
      headerName: "Alpha Pattern",
      width: 220,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.alphaPattern) {
          return "";
        }
        return <p>{params.row.alphaPattern}</p>;
      },
    },
    {
      field: "betaPattern",
      headerName: "Beta Pattern",
      width: 220,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.betaPattern) {
          return "";
        }
        return <p>{params.row.betaPattern}</p>;
      },
    },

    {
      field: "openPricePC",
      headerName: "Open Price",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.openPricePC) {
          return "";
        }
        return <p>{params.row.openPricePC}</p>;
      },
    },
    {
      field: "openPriceIC",
      headerName: "Open Price",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.openPriceIC) {
          return "";
        }
        return <p>{params.row.openPriceIC}</p>;
      },
    },
    {
      field: "closePricePC",
      headerName: "Close Price",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.closePricePC) {
          return "";
        }
        return <p>{params.row.closePricePC}</p>;
      },
    },
    {
      field: "closePriceIC",
      headerName: "Close Price",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.closePriceIC) {
          return "";
        }
        return <p>{params.row.closePriceIC}</p>;
      },
    },
    {
      field: "stopLossPC",
      headerName: "Stop Loss",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const distance = params.row.stopLossPC;

        if (distance === "" || distance === null || distance === undefined) {
          return "";
        }

        const unit = checkStopLossType(params.row.pair) || "";

        return (
          <p>
            {distance} {unit}
          </p>
        );
      },
    },
    {
      field: "stopLossIC",
      headerName: "Stop Loss",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const distance = params.row.stopLossIC;

        if (distance === "" || distance === null || distance === undefined) {
          return "";
        }

        const unit = checkStopLossType(params.row.pair) || "";

        return (
          <p>
            {distance} {unit}
          </p>
        );
      },
    },
    {
      field: "stopLossPricePC",
      headerName: "SL Price",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.stopLossPricePC) {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
        return <p>{params.row.stopLossPricePC}</p>;
      },
    },
    {
      field: "stopLossPriceIC",
      headerName: "SL Price",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.row.stopLossPriceIC) {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
        return <p>{params.row.stopLossPriceIC}</p>;
      },
    },
    {
      field: "newTransactionIC",
      headerName: "Transaction",
      width: 130,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          if (!params.row.newTransactionIC) {
            return (
              <HorizontalRuleIcon
                sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
              />
            );
          } else {
            return <p>{params.row.newTransactionIC}</p>;
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "transanctionNotesIC",
      headerName: "Note",
      width: 300,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Investor Capital") {
          if (!params.row.transanctionNotesIC) {
            return (
              <HorizontalRuleIcon
                sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
              />
            );
          } else {
            return <p>{params.row.transanctionNotesIC}</p>;
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "newTransactionPC",
      headerName: "Transaction",
      width: 130,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Personal Capital") {
          if (!params.row.newTransactionPC) {
            return (
              <HorizontalRuleIcon
                sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
              />
            );
          } else {
            return <p>{params.row.newTransactionPC}</p>;
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
    {
      field: "transanctionNotesPC",
      headerName: "Note",
      width: 300,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.equityType === "Personal Capital") {
          if (!params.row.transanctionNotesPC) {
            return (
              <HorizontalRuleIcon
                sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
              />
            );
          } else {
            return <p>{params.row.transanctionNotesPC}</p>;
          }
        } else {
          return (
            <HorizontalRuleIcon
              sx={{ color: theme[0] === "dark" ? "#FCFCFF" : "black" }}
            />
          );
        }
      },
    },
  ];

  const PC_Fields = [
    "outcomePC",
    "profitLossPercentagePC",
    "percentWithFeesPC",
    "profitLossDollarPersonal",
    "feePC",
    "swapPC",
    "rollingFeesPC",
    "returnTotalsPersonal",
    "returnTotalsPersonalGross",
    "returnTotalsPersonalNet",
    "returnNetPersonal",
    "stopLossPC",
    "lotsPC",
    "unitsPC",
    "moneyPC",
    "openPricePC",
    "closePricePC",
    "rollingPercentPCGross",
    "rollingPercentPCNet",
    "rollingBalancePC",
    "rollingBalancePCGross",
    "newTransactionPC",
    "transanctionNotesPC",
    "stopLossPricePC",
  ];
  const IC_Fields = [
    "outcomeIC",
    "profitLossPercentageIC",
    "percentWithFeesIC",
    "profitLossDollarInvestor",
    "feeIC",
    "swapIC",
    "rollingFeesIC",
    "returnTotalsInvestor",
    "returnTotalsInvestorGross",
    "returnNetInvestor",

    "returnTotalsInvestorNet",
    "stopLossIC",
    "lotsIC",
    "unitsIC",
    "moneyIC",
    "openPriceIC",
    "closePriceIC",
    "rollingPercentICGross",
    "rollingPercentICNet",
    "rollingBalanceIC",
    "rollingBalanceICGross",
    "newTransactionIC",
    "transanctionNotesIC",
    "stopLossPriceIC",
  ];

  // Determine which columns to show based on selected account
  const accountId =
    selectedAccountId || localStorage.getItem("selected-account-id") || "all";

  // Determine account type
  let accountType = null;
  if (accountId === "All") {
    accountType = "all";
  } else if (accountId === "All Personal") {
    accountType = "Personal";
  } else if (accountId === "All Investor") {
    accountType = "Investor";
  } else {
    const account = capitalAccounts.find((acc) => acc.id === accountId);
    accountType = account ? account.type : "all";
  }

  // Filter columns based on account type
  if (accountType === "Personal") {
    let filteredData = array.filter((obj) => !IC_Fields.includes(obj.field));
    return filteredData;
  } else if (accountType === "Investor") {
    let filteredData = array.filter((obj) => !PC_Fields.includes(obj.field));
    return filteredData;
  } else {
    return array;
  }
};

export default ColumnsAll;
